import React from 'react';
import { IconProps } from '../types';
const MinecraftPufferfishBucket: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="2" y="1" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="3" y="1" width="1" height="1" fill="rgba(182, 120, 38, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(251, 167, 12, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(251, 167, 12, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="1" y="2" width="1" height="1" fill="rgba(66, 155, 186, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(255, 201, 8, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(255, 201, 8, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(255, 201, 8, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(182, 120, 38, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(53, 138, 168, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(29, 44, 38, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(250, 250, 250, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(251, 167, 12, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(255, 201, 8, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(251, 167, 12, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(251, 167, 12, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(182, 120, 38, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(163, 113, 23, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(252, 229, 188, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(238, 207, 155, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(250, 250, 250, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(29, 44, 38, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="13" y="4" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="14" y="4" width="1" height="1" fill="rgba(66, 155, 186, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(252, 229, 188, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(29, 44, 38, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(29, 44, 38, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(252, 229, 188, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(216, 149, 26, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(53, 138, 168, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(126, 168, 189, 255)" />
<rect x="13" y="5" width="1" height="1" fill="rgba(66, 155, 186, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(68, 111, 233, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(210, 164, 77, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(191, 132, 27, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(35, 79, 204, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(35, 79, 204, 255)" />
<rect x="11" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(35, 79, 204, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(68, 111, 233, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(35, 79, 204, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(35, 79, 204, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(68, 111, 233, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="13" y="8" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="13" y="9" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(52, 95, 218, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="3" y="13" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="4" y="14" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(216, 216, 216, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(114, 114, 114, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="5" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(53, 53, 53, 255)" />
</svg>);
export default MinecraftPufferfishBucket;